import React, { useState } from 'react';
import { TransfersTable } from '../components/portability/TransfersTable';
import { CreateTransferModal } from '../components/portability/CreateTransferModal';
import { useClientAccess } from '../hooks/useClientAccess';
import { useI18n } from '../contexts/I18nContext';
import '../styles/config-templates.css';
import '../styles/users.css';
import '../styles/portability.css';

/**
 * Portability: a client taking over gateways of another client. A client's
 * administrator opens the request, ANEP can open one on a client's behalf;
 * the owner's administrator answers it, an ANEP manager as a last resort.
 */
export const PortabilityPage: React.FC = () => {
  const { isClientAdmin, isAnepStaff } = useClientAccess();
  const { t } = useI18n();
  const [showCreate, setShowCreate] = useState(false);
  const [refresh, setRefresh] = useState(0);

  return (
    <div className="page portability-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('portability.title')}</h1>
          <p>{t('portability.subtitle')}</p>
        </div>
        <div className="page-actions">
          {(isClientAdmin || isAnepStaff) && (
            <button type="button" className="pt-add" data-testid="btn-add-transfer" onClick={() => setShowCreate(true)}>
              <span className="add-type-icon" aria-hidden="true">+</span>
              {t('portability.add')}
            </button>
          )}
        </div>
      </div>

      <div className="page-content portability-content">
        <TransfersTable refreshTrigger={refresh} />
      </div>

      <CreateTransferModal isOpen={showCreate} onClose={() => setShowCreate(false)} onCreated={() => setRefresh((n) => n + 1)} />
    </div>
  );
};
